import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getCommCodes: param => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getBatchStatusList: ({ searchParams, currentPage, pageUnit }) => {		
		let queryStr = '';
		//console.log('searchParams', searchParams);

		if (searchParams.pgmId !== undefined || searchParams.jobGroupId !== undefined || searchParams.jobId !== undefined || searchParams.strtDt !== undefined) {
			queryStr = objectToQuerystring({
				pgmId: searchParams.pgmId,
				jobGroupId: searchParams.jobGroupId,
				jobId: searchParams.jobId,
				jobNm: searchParams.jobNm,
				useYn: searchParams.useYn,				
				currentPage,
				pageUnit
			});
		}
		//console.log('queryStr', queryStr);		
		return client
			.get(`${BASE_URL}/comm/qmsbase/batchStatus/v1/batchStatus` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	sendBatchStart: (selectedRow) => {		
		let queryStr = '';
		//('searchParams', selectedRow);
		debugger;
		// if (searchParams.pgmId !== undefined || searchParams.jobGroupId !== undefined || searchParams.jobId !== undefined || searchParams.strtDt !== undefined) {
		// 	queryStr = objectToQuerystring({
		// 		pgmId: searchParams.pgmId,
		// 		jobGroupId: searchParams.jobGroupId,
		// 		jobId: searchParams.jobId,
		// 		jobNm: searchParams.jobNm,
		// 		useYn: searchParams.useYn,				
		// 		currentPage,
		// 		pageUnit
		// 	});
		// }
		if (selectedRow.pgmId !== undefined || selectedRow.jobGroupId !== undefined || selectedRow.jobId !== undefined) {
			queryStr = objectToQuerystring({
				pgmId: selectedRow.pgmId,
				jobGroupId: selectedRow.jobGroupId,
				jobId: selectedRow.jobId,
				jobNm: selectedRow.jobNm				
			});
		}	
		//console.log('queryStr', queryStr);		
		return client
			.get(`${BASE_URL}/comm/qmsbase/batchStatus/v1/sendBatch` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}		
};
